module.exports = __webpack_public_path__ + "static/media/jetson_one_render_21.44f588cf.jpg";